import {css} from '@emotion/react'
import {useState} from 'react'
import {colors} from '../../../constants'

import DownChevron from '../../../images/browser/down-chevron.svg'
import {createMarkup} from '../../../util/datoCmsDataFactory'

const text = {
    en: {
        headerText: `FAQ`,
        faqData: [
            {
                question: `Is Startpage for Mac and PC free?`,
                answer: `<p>Yes! The Startpage browsing app is free to download and to use. What's more, we don't collect or sell your data, so you won't be paying with your privacy either.</p>`,
            },
            {
                question: `How does the Startpage browser protect my privacy?`,
                answer: `
                        <p><em>Data protection</em>: Startpage immediately deletes your search and browsing data. Unlike some of the most widely used browsers, Startpage does not collect or profit from your personal data. Additionally, Startpage automatically blocks trackers and cookies, preventing hidden trackers from collecting your data and slowing down your browsing. A list of total trackers blocked helps you monitor threats and see how Startpage protects you.</p>
        
                        <p><em>Truly private browsing</em>: Private browsing windows, sometimes called Incognito, usually aren't very private. While useful in preventing browsing data from being stored on your device, they don’t prevent your ISP, sites you visit, or even your browser itself from tracking your activity. To remedy this, Startpage exclusively offers Stealth, a private browsing mode that adds additional protections to shield your browsing activity. Browsing in Stealth mode is similar to a VPN, in that it masks your IP address and personal data when you visit a site. And since a Stealth mode connection is handled through a proxy, not a direct connection, any site you visit will see only Startpage, not you.</p>
        
                        <p><em>Speed and convenience</em>: Use the Zap button to delete your browsing history and close all tabs with a single click.</p>
                `,
            },
            {
                question: `Will there be a browsing app for other platforms (e.g., Linux, iOS, Android)`,
                answer: `<p>Yes! For our initial launch, we are focusing on macOS and Windows on desktop, but support for other platforms such as Linux and mobile (iOS and Android) is coming in the future.</p>`,
            },
            {
                question: `How does Stealth keep me private?`,
                answer: `<p>Browse websites privately in Stealth mode. Unlike other private windows, your location and IP address are both masked from the websites you visit, similar to a VPN. All browsing history, cookies, and other traces of your browsing session are deleted when you close a Stealth window.</p>`,
            },
            {
                question: `What technology is Startpage for Mac and PC built on?`,
                answer: `<p>Startpage is built on the same proven, reliable, open source technology that powers Mozilla's Firefox Browser. We have also added our own enhancements like Stealth and Zap to further protect your privacy.</p>`,
            },
            {
                question: `Does Startpage collect and sell my personal data?`,
                answer: `
                    <p>No! For nearly 20 years, Startpage has been a leader in the movement toward greater online privacy. We never collect or sell user data.</p>
                    <p>For more information visit our <a href="https://www.startpage.com/en/privacy-policy">Privacy Policy</a></p>
                `,
            },
            {
                question: `How does Startpage make money?`,
                answer: `
                    <p>Startpage relies on the revenue generated by showing ads. Our privacy-minded ads are contextual, meaning they are based on your search query, NOT targeted based on your personal data. Therefore, your personal data and search history are shielded from advertisers and third parties.</p>
                    <p>Contextual ads on the results page are anonymously generated solely based on the search terms you entered, not on your past searches, browsing history, or tracking cookies. Startpage does NOT save or share any privacy-sensitive user data, including IP address and cookie information.</p>
                    <p>It's just one more way we protect your privacy. For more information, visit <a href="https://www.startpage.com/privacy-please/startpage-articles/whats-startpages-revenue-model">our blog</a></p>
                `,
            },
        ],
    },
    de: {
        headerText: `FAQ`,
        faqData: [
            {
                question: `Ist Startpage für Mac und PC kostenlos?`,
                answer: `<p>Ja! Die Startpage-Browser-App steht kostenlos zum Download und zur Nutzung zur Verfügung. Wir sammeln oder verkaufen deine Daten auch nicht, um damit Geld zu verdienen.</p>`,
            },
            {
                question: `Wie schützt der Startpage Browser meine Privatsphäre?`,
                answer: `
                        <p><em>Datenschutz</em>: Startpage löscht deine Suchbegriffe und deine Nutzerdaten direkt nach der Suche. Im Gegensatz zu vielen anderen Browsern sammelt und speichert Startpage deine Daten nicht, um daraus Profit zu schlagen. Startpage blockiert auch Tracker und Cookies automatisch und schützt dich so vor versteckten Trackern, die deine Daten sammeln und dein Surferlebnis verlangsamen. Eine Liste aller Tracker, die blockiert wurden, hilft dir, Bedrohungen zu erkennen und mitzuverfolgen, wie dich Startpage schützt.</p>
        
                        <p><em>Echter Datenschutz</em>: Private Browserfenster, wie der „Incognito-Modus“ oder „Private Fenster“ halten normalerweise nicht, was der Name verspricht. Sie sorgen zwar dafür, dass dein Surfverhalten nicht auf deinem Gerät gespeichert wird aber halten deinen Internetanbieter, die Seiten, die du besuchst und sogar deinen Browser selbst nicht davon ab, deine Aktivitäten zu verfolgen. Als Lösung für dieses Problem beinhaltet der Startpage Browser einen Stealth-Modus. Stealth ist ein privater Modus, der zusätzliche Datenschutzfunktionen beinhaltet. Surfen mit Stealth ist der Nutzung eines VPN-Services ganz ähnlich: Deine IP-Adresse und persönliche Daten sind für Webseiten, die du besuchst, nicht sichtbar. Und da Sitzungen im Stealth-Mode über einen Proxy-Server laufen, sehen Seiten, die du besuchst, nur Startpage aber nicht dich.</p>
        
                        <p><em>Geschwindigkeit und Komfort</em>: Mit der Zap-Funktion schließt du alle Tabs und löschst deinen Browserverlauf mit nur einem Klick.</p>
                `,
            },
            {
                question: `Gibt es bald auch eine Browser-App für andere Betriebssysteme (z. B. Linux, iOS, Android)`,
                answer: `<p>Ja! Zunächst wird der Browser nur für macOS und Windows angeboten. Andere Plattformen wie Linux und mobile Betriebssysteme (iOS und Android) werden bald auch unterstützt.</p>`,
            },
            {
                question: `Wie schützt mich Stealth?`,
                answer: `<p>Surfe privat auf Websites im Stealth-Modus. Im Gegensatz zu privaten Modi anderer Browser werden sowohl dein Standort als auch deine IP-Adresse vor den von dir besuchten Websites verborgen, ähnlich wie bei der Nutzung eines VPN. Der gesamte Browserverlauf, Cookies und andere Spuren deiner Sitzung werden gelöscht, sobald du das Stealth-Fenster schließt.</p>`,
            },
            {
                question: `Auf welcher Technologie basiert Startpage für Mac und PC?`,
                answer: `<p>Startpage basiert auf der gleichen bewährten, zuverlässigen und quelloffenen Technologie wie Mozillas Firefox-Browser. Zudem haben wir eigene Funktionen wie Stealth und Zap hinzugefügt, um deine Privatsphäre noch besser zu schützen.</p>`,
            },
            {
                question: `Sammelt und verkauft Startpage meine persönlichen Daten?`,
                answer: `
                    <p>Nein! Seit fast 20 Jahren ist Startpage ein führendes Unternehmen im Bereich Datenschutz im Internet. Wir sammeln oder verkaufen niemals Nutzerdaten.</p>
                    <p>Weitere Informationen erhältst du in unserer <a href="https://www.startpage.com/de/privacy-policy">Datenschutzrichtlinie</a></p>
                `,
            },
            {
                question: `Wie verdient Startpage Geld?`,
                answer: `
                    <p>Startpage verdient durch die Anzeige von Werbung Geld. Unsere datenschutzfreundlichen Anzeigen sind kontextbezogen, d. h. sie basieren allein auf deiner Suchanfrage und NICHT auf deinen persönlichen Daten. Daher sind deine persönlichen Daten und dein Suchverlauf vor Werbetreibenden und weiteren Dritten geschützt.</p>
                    <p>Die kontextbezogenen Anzeigen auf der Ergebnisseite werden anonym nur auf der Grundlage der eingegebenen Suchbegriffe generiert, nicht auf der Grundlage von früheren Suchanfragen, deines Browserverlaufs oder von Tracking-Cookies. Startpage speichert oder teilt KEINE datenschutzrelevanten Nutzerdaten, einschließlich IP-Adresse und Cookie-Informationen.</p>
                    <p>Damit bieten wir eine weitere Möglichkeit, deine Privatsphäre zu schützen. Weitere Informationen findest du in <a href="https://www.startpage.com/privacy-please/startpage-articles/whats-startpages-revenue-model">unserem Blog</a></p>
                `,
            },
        ],
    },
    nl: {
        headerText: `Veelgestelde vragen`,
        faqData: [
            {
                question: `Is Startpage voor Mac en PC gratis?`,
                answer: `<p>Ja! De Startpage browser app is gratis te downloaden en te gebruiken. Bovendien verzamelen of verkopen we je gegevens niet, dus je betaalt ook niet met je privacy.</p>`,
            },
            {
                question: `Hoe beschermt de Startpage browser mijn privacy?`,
                answer: `
                        <p><em>Gegevensbescherming</em>: Startpage verwijderd onmiddelijk je zoek- en surfgegevens. In tegenstelling tot sommige van de meest gebruikte browsers, verzamelt of profiteert Startpage niet van je persoonlijke gegevens. Bovendien blokkeert Startpage automatisch trackers en cookies, waardoor verborgen trackers je gegevens niet kunnen verzamelen en het browsen niet kunnen vertragen. Een lijst met het totale aantal geblokkeerde trackers helpt je bij het monitoren van bedreigingen en laat zien hoe Startpage je beschermt.</p>
        
                        <p><em>Echte privacy</em>: privévensters, soms "Incognito" genoemd, zijn meestal niet zo privacy-vriendelijk. Hoewel ze nuttig zijn om te voorkomen dat je zoekgeschiedenis wordt opgeslagen op je apparaat, voorkomen ze niet dat je ISP, de websites die je bezoekt, of zelfs je browser zelf je activiteiten kunnen volgen. Om dit te verhelpen biedt Startpage exclusief Stealth aan, een privénavigatie-modus die extra bescherming biedt om je navigatiegegevens af te schermen. Browsen in Stealth-modus is vergelijkbaar met een VPN, in de zin dat het je IP-adres en persoonlijke gegevens maskeert wanneer je een website bezoekt. En omdat de verbinding van de Stealth-modus wordt afgehandeld via een proxy in plaats van een directe verbinding, ziet elke website die je bezoekt alleen Startpage, niet jou.</p>
        
                        <p><em>Snelheid en gemak</em>: Gebruik de Zap-knop om je navigatiegeschiedenis te wissen en alle tabbladen met één klik te sluiten.</p>
                `,
            },
            {
                question: `Komt er een browser app voor andere platforms (bijv. Linux, iOS, Android)?`,
                answer: `<p>Ja! Voor de eerste release van de browser app richten we ons op macOS en Windows, maar ondersteuning voor andere platforms zoals Linux en mobiel (iOS en Android) komt er in de toekomst aan.</p>`,
            },
            {
                question: `Hoe beschermt Stealth mij?`,
                answer: `<p>Surf privé op websites in Stealth-modus. In tegenstelling tot andere privévensters, worden je locatie en IP-adres beide gemaskeerd voor de website die je bezoekt, vergelijkbaar met een VPN. Alle navigatiegeschiedenis, cookies, en andere sporen van je navigatiesessie worden verwijderd wanneer je een Stealth-venster sluit.</p>`,
            },
            {
                question: `Op welke technologie is Startpage voor Mac en PC gebouwd?`,
                answer: `<p>Startpage is gebouwd op dezelfde bewezen, betrouwbare, open source technologie als Mozilla's Firefox browser. We hebben ook onze eigen verbeteringen toegevoegd, zoals Stealth en Zap, om je privacy verder te beschermen.</p>`,
            },
            {
                question: `Verzamelt en verkoopt Startpage mijn persoonlijke gegevens?`,
                answer: `
                    <p>Nee! Al bijna 20 jaar is Startpage een leider in de beweging naar meer online privacy. Wij verzamelen of verkopen nooit gebruikersgegevens.</p>
                    <p>Meer informatie kun je vinden in ons <a href="https://www.startpage.com/nl/privacy-policy">privacybeleid</a></p>
                `,
            },
            {
                question: `Hoe verdient Startpage geld?`,
                answer: `
                    <p>Startpage is afhankelijk van de inkomsten uit het tonen van advertenties. Onze privacy-vriendelijke advertenties zijn contextueel, wat betekent dat ze gebaseerd zijn op je zoekopdracht, en niet op je persoonlijke gegevens. Daarom worden je persoonlijke gegevens en zoekgeschiedenis afgeschermd van adverteerders en derden.</p>
                    <p>Contextuele advertenties op de zoekresultatenpagina worden uitsluitend anoniem gegenereerd op basis van de door jou ingevoerde zoektermen, niet op basis van je eerdere zoekopdrachten, navigatiegeschiedenis, of tracking cookies. Startpage bewaart of deelt geen privacygevoelige gebruikersgegevens, inclusief IP-adres en cookie informatie.</p>
                    <p>Het is nog een manier waarop we je privacy beschermen. Meer informatie kun je vinden in <a href="https://www.startpage.com/privacy-please/startpage-articles/whats-startpages-revenue-model">onze blog</a></p>
                `,
            },
        ],
    },
}

const FaqSection = ({overrideStyles, languageCode}) => {
    const {headerText, faqData} = text[languageCode]

    const [expandedFaqs, setExpandedFaqs] = useState(new Array(faqData.length).fill(false))

    const onFaqClick = (i) => {
        return () => {
            const expFaqs = [...expandedFaqs]
            expFaqs[i] = !expFaqs[i]
            setExpandedFaqs(expFaqs)
        }
    }

    return (
        <section
            className="faq-section"
            css={css`
                background-image: url(data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTQ0MCIgaGVpZ2h0PSI3NjAiIHZpZXdCb3g9IjAgMCAxNDQwIDc2MCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHJlY3Qgd2lkdGg9IjE0NDAiIGhlaWdodD0iNzYwIiBmaWxsPSJ1cmwoI3BhaW50MF9saW5lYXJfNjg4XzE0Mzc2KSIvPgo8cGF0aCBkPSJNMTQ0MCAzMjUuNjIxQzk5NS4yIDI1My42MjEgMzA2IDI3Ny42MjIgNCAzNDcuNjIxVjc1OS42MjJIMTQ0MFYzMjUuNjIxWiIgZmlsbD0idXJsKCNwYWludDFfbGluZWFyXzY4OF8xNDM3NikiLz4KPGRlZnM+CjxsaW5lYXJHcmFkaWVudCBpZD0icGFpbnQwX2xpbmVhcl82ODhfMTQzNzYiIHgxPSI3MjAiIHkxPSIzLjYyOTc5ZS0wNSIgeDI9IjEzNjYuMDciIHkyPSI5NDEuMzYiIGdyYWRpZW50VW5pdHM9InVzZXJTcGFjZU9uVXNlIj4KPHN0b3Agc3RvcC1jb2xvcj0iIzY2NzdGQiIvPgo8c3RvcCBvZmZzZXQ9IjEiIHN0b3AtY29sb3I9IiMyOUREQ0MiLz4KPC9saW5lYXJHcmFkaWVudD4KPGxpbmVhckdyYWRpZW50IGlkPSJwYWludDFfbGluZWFyXzY4OF8xNDM3NiIgeDE9IjQiIHkxPSI1NTQiIHgyPSIxNDQwIiB5Mj0iNTU0IiBncmFkaWVudFVuaXRzPSJ1c2VyU3BhY2VPblVzZSI+CjxzdG9wIHN0b3AtY29sb3I9IiM2Nzc4RkMiLz4KPHN0b3Agb2Zmc2V0PSIxIiBzdG9wLWNvbG9yPSIjMjlERENDIi8+CjwvbGluZWFyR3JhZGllbnQ+CjwvZGVmcz4KPC9zdmc+Cg==);
                background-repeat: no-repeat;
                background-size: cover;
                padding: 80px 2rem;
                ${overrideStyles};
            `}
        >
            <div
                className="content"
                css={css`
                    max-width: 960px;
                    margin: 0 auto;
                `}
            >
                <h2
                    css={css`
                        text-align: center;
                        font-size: 40px;
                        font-weight: 800;
                        color: ${colors.whisperLight};
                    `}
                >
                    {headerText}
                </h2>
                <div
                    className="faqs"
                    css={css`
                        margin: 32px 0 20px;
                    `}
                >
                    {faqData.map(({question, answer}, i) => {
                        return (
                            <div
                                className="faq"
                                key={i}
                                css={css`
                                    background: ${colors.whisperLight};
                                    border-radius: 10px;
                                    margin-bottom: 20px;
                                    &:hover {
                                        cursor: pointer;
                                    }
                                `}
                            >
                                <div
                                    className="question"
                                    css={css`
                                        display: flex;
                                        align-items: center;
                                        justify-content: space-between;
                                        padding: 40px;
                                        line-height: 24px;
                                        font-size: 18px;
                                    `}
                                    onClick={onFaqClick(i)}
                                    role="button"
                                    tabIndex={-1}
                                    onKeyUp={onFaqClick(i)}
                                >
                                    <p>{question}</p>
                                    <div
                                        className="chevron"
                                        css={css`
                                            transform: rotate(${expandedFaqs[i] ? '180deg' : '0deg'});
                                        `}
                                    >
                                        <DownChevron />
                                    </div>
                                </div>
                                {expandedFaqs[i] && (
                                    <div
                                        className="answer"
                                        css={css`
                                            padding: 0 40px 40px;
                                            p {
                                                margin-bottom: 20px;
                                                line-height: 24px;
                                            }
                                            a {
                                                color: ${colors.brandBlue};
                                                text-decoration: underline;
                                                /* margin-left: 5px; */
                                            }
                                        `}
                                        dangerouslySetInnerHTML={createMarkup(answer)}
                                    />
                                )}
                            </div>
                        )
                    })}
                </div>
            </div>
        </section>
    )
}

export default FaqSection
